import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-sm-flex align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "bg-transparent text-primary transition p-0 border-0"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-search-interface-symbol" })
], -1)
const _hoisted_6 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_7 = { class: "table-responsive" }
const _hoisted_8 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
    }, "NOMBRE DEL JUEGO"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0 text-center"
    }, "JUEGO PREDETERMINADO"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, "ACCIONES")
  ])
], -1)
const _hoisted_10 = { class: "shadow-none lh-1 fw-medium text-black-emphasis title ps-0" }
const _hoisted_11 = { class: "d-flex align-items-center" }
const _hoisted_12 = { class: "d-flex align-items-center ms-5 fs-md-15 fs-lg-16" }
const _hoisted_13 = { class: "shadow-none lh-1 fw-medium text-black-emphasis title ps-0 text-center" }
const _hoisted_14 = { class: "d-flex justify-content-center" }
const _hoisted_15 = {
  key: 0,
  class: "circle"
}
const _hoisted_16 = { class: "action-link" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CreateNewGameModal = _resolveComponent("CreateNewGameModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("a", {
          class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none",
          href: "#",
          "data-bs-toggle": "modal",
          "data-bs-target": "#createNewGameModal",
          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleModalClosed && _ctx.handleModalClosed(...args)), ["prevent"]))
        }, [
          _createTextVNode(" Agregar Juego "),
          _hoisted_4
        ])
      ]),
      _createElementVNode("form", {
        class: "search-box position-relative me-15",
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
      }, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "form-control shadow-none text-black rounded-0 border-0",
          placeholder: "Buscar Juego",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchQuery) = $event))
        }, null, 512), [
          [_vModelText, _ctx.searchQuery]
        ]),
        _hoisted_5
      ], 32)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("table", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredGames, (game, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("th", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, _toDisplayString(game.name), 1)
                  ])
                ]),
                _createElementVNode("th", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    (game.default)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_15))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("td", _hoisted_16, [
                  _createElementVNode("i", {
                    class: "ph ph-pencil action-link cursor-pointer",
                    style: {"font-size":"24px"},
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#createNewGameModal",
                    onClick: ($event: any) => (_ctx.openModal(game))
                  }, null, 8, _hoisted_17),
                  _createElementVNode("i", {
                    class: "ph ph-trash ms-2 action-link cursor-pointer",
                    style: {"font-size":"24px"},
                    onClick: ($event: any) => (_ctx.deleteGame(game.id))
                  }, null, 8, _hoisted_18)
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _createVNode(_component_CreateNewGameModal, {
      axios: _ctx.axios,
      id: _ctx.selectedItem?.id,
      "no-close-on-backdrop": true,
      title: _ctx.title,
      onModalClosed: _ctx.handleModalClosed
    }, null, 8, ["axios", "id", "title", "onModalClosed"])
  ]))
}